// @flow
import I18n from '../i18n/I18n'
import _ from 'lodash'

export default class TaxesType {

  static getLegalBankFeeTaxes = () => ([
    {
      label: I18n.tr('components.vat_chooser.bank.0'),
      value: 0,
    },
    {
      label: I18n.tr('components.vat_chooser.bank.8'),
      value: 8.5,
    },
    {
      label: I18n.tr('components.vat_chooser.bank.20'),
      value: 20.0,
    },
  ])

  static getTaxes = () => ([
    {
      label: I18n.tr('components.vat_chooser.countries.be'),
      value: 'be',
      disabled: true,
      taxes: [
        {
          label: '6.0 %',
          value: 6.0,
          disabled: false,
        },
        {
          label: '12.0 %',
          value: 12.0,
          disabled: false,
        },
        {
          label: '21.0 %',
          value: 21.0,
          disabled: false,
        },
      ],
    },
    {
      label: I18n.tr('components.vat_chooser.countries.de'),
      value: 'de',
      disabled: true,
      taxes: [
        {
          label: '7.0 %',
          value: 7.0,
          disabled: false,
        },
        {
          label: '19.0 %',
          value: 19.0,
          disabled: false,
        },
      ],
    },
    {
      label: I18n.tr('components.vat_chooser.countries.fr'),
      value: 'fr',
      disabled: true,
      taxes: [
        {
          label: '5.5 %',
          value: 5.5,
          disabled: false,
        },
        {
          label: '10.0 %',
          value: 10,
          disabled: false,
        },
        {
          label: '20.0 %',
          value: 20,
          disabled: false,
        },
      ],
    },
    {
      label: 'La réunion',
      value: '',
      disabled: true,
      taxes: [
        {
          label: '2.1 %',
          value: 2.1,
        },
        {
          label: '8.5 %',
          value: 8.5,
        },
      ]
    },
    {
      label: I18n.tr('components.vat_chooser.countries.lu'),
      value: 'lu',
      disabled: true,
      taxes: [
        {
          label: '3.0 %',
          value: 3.0,
          disabled: false,
        },
        {
          label: '14.0 %',
          value: 14.0,
          disabled: false,
        },
        {
          label: '17.0 %',
          value: 17.0,
          disabled: false,
        },
      ],
    },
    {
      label: I18n.tr('components.vat_chooser.countries.ch'),
      value: 'ch',
      disabled: true,
      taxes: [
        {
          label: '2.6 %',
          value: 2.6,
          disabled: false,
        },
        {
          label: '8.1 %',
          value: 8.1,
          disabled: false,
        },
      ],
    },
  ]);

  /**
   * Return all feature type choice
   *
   * @return array
   */
  static getChoices(): Array<Object> {
    return _.sortBy(TaxesType.getTaxes(), ['label']).map(country => ({
      label: country.label,      // group label
      options: country.taxes     // options inside the group
    }));
  }
}
